import * as React from "react";
const SvgSettingActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#settingActive_svg__a)">
      <path
        fill="#fff"
        d="M20.091 9.221c-1.81 0-2.549-1.279-1.65-2.848.52-.91.21-2.069-.699-2.589l-1.729-.99c-.79-.47-1.81-.19-2.279.6l-.11.19c-.9 1.57-2.379 1.57-3.288 0l-.11-.19a1.64 1.64 0 0 0-2.259-.6l-1.73.99c-.909.52-1.219 1.69-.699 2.599.91 1.56.17 2.838-1.639 2.838-1.04 0-1.899.85-1.899 1.9v1.759c0 1.04.85 1.899 1.899 1.899 1.81 0 2.549 1.28 1.64 2.848-.52.91-.21 2.07.699 2.589l1.729.99c.79.47 1.81.19 2.279-.6l.11-.19c.9-1.57 2.379-1.57 3.288 0l.11.19c.47.79 1.49 1.07 2.279.6l1.73-.99c.909-.52 1.218-1.69.699-2.589-.91-1.569-.17-2.848 1.639-2.848 1.04 0 1.899-.85 1.899-1.9v-1.758a1.92 1.92 0 0 0-1.909-1.9m-8.096 6.028A3.255 3.255 0 0 1 8.747 12c0-1.789 1.459-3.248 3.248-3.248S15.243 10.21 15.243 12s-1.459 3.249-3.248 3.249"
      />
    </g>
    <defs>
      <clipPath id="settingActive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingActive;
